import { ComponentProps } from 'react';
import type { SvgIconProps } from '@mui/material';
import {
  Pagination as MuiPagination,
  PaginationItem as MuiPaginationItem,
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableContainer as MuiTableContainer,
  TableFooter as MuiTableFooter,
  TableHead as MuiTableHead,
  TablePagination as MuiTablePagination,
  TableRow as MuiTableRow,
  TableSortLabel as MuiTableSortLabel,
} from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import {
  PaginationProps,
  TableBodyProps,
  TableCellProps,
  TableFooterProps,
  TableHeadProps,
  TablePaginationProps,
  TableProps,
  TableRowProps,
  TableSortLabelProps,
} from './types';

// Wrapper components for custom icons in pagination slots
const PreviousIcon = (props: SvgIconProps) => (
  <SystemIcon iconName="CaretLeft" size={14} {...props} />
);

const NextIcon = (props: SvgIconProps) => (
  <SystemIcon iconName="CaretRight" size={14} {...props} />
);

export const Table = (props: TableProps) => <MuiTable {...props} />;
export const TableContainer = (
  props: ComponentProps<typeof MuiTableContainer>,
) => <MuiTableContainer {...props} />;
export const TableHead = (props: TableHeadProps) => <MuiTableHead {...props} />;
export const TableBody = (props: TableBodyProps) => <MuiTableBody {...props} />;
export const TableFooter = (props: TableFooterProps) => (
  <MuiTableFooter {...props} />
);
export const TableRow = (props: TableRowProps) => <MuiTableRow {...props} />;
export const TableCell = (props: TableCellProps) => <MuiTableCell {...props} />;
export const TablePagination = (props: TablePaginationProps) => (
  <MuiTablePagination {...props} />
);
export const TableSortLabel = (props: TableSortLabelProps) => (
  <MuiTableSortLabel {...props} />
);
export const Pagination = (props: PaginationProps) => (
  <MuiPagination
    renderItem={(item) => (
      <MuiPaginationItem
        slots={{ previous: PreviousIcon, next: NextIcon }}
        sx={(theme) => {
          const isPreviousOrNext =
            item.type === 'previous' || item.type === 'next';
          return {
            ...(isPreviousOrNext
              ? {
                  '&.MuiPaginationItem-previousNext': {
                    backgroundColor: 'transparent !important',
                    '&:hover': {
                      backgroundColor: 'transparent !important',
                      transform: 'none !important',
                    },
                    '&.Mui-disabled': {
                      backgroundColor: 'transparent !important',
                      '&:hover': {
                        backgroundColor: 'transparent !important',
                        transform: 'none !important',
                      },
                    },
                  },
                }
              : {
                  '&:hover': {
                    backgroundColor: `${
                      theme.palette.mode === 'dark'
                        ? theme.palette.grey[600]
                        : theme.palette.grey[200]
                    } !important`,
                  },
                }),
          };
        }}
        {...item}
      />
    )}
    {...props}
  />
);

export { EnhancedTable } from './enhanced-table';
export * from './types';
